document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.homepage-banner');
  const sliderEl = banner?.querySelector('.homepage-banner__slider');
  if (!sliderEl) return;

  const enableAutoplay = sliderEl.dataset.autoplay === 'true';
  const autoplayDelay = parseInt(sliderEl.dataset.autoplaySpeed, 10) * 1000;
  const strings = window.accessibilityStrings || {};

  function sizeMedia() {
    const ratio = Number(window.matchMedia('(max-width: 767px)').matches
      ? sliderEl.dataset.mobileRatio : sliderEl.dataset.desktopRatio);
    if (!(ratio > 0) || !sliderEl.clientWidth) return;
    const height = Math.floor(sliderEl.clientWidth / ratio) + 'px';
    sliderEl.querySelectorAll('.homepage-banner__media').forEach(function (media) {
      if (media.style.height !== height) media.style.height = height;
    });
  }
  sizeMedia();
  if (typeof ResizeObserver === 'function') new ResizeObserver(sizeMedia).observe(sliderEl);
  else window.addEventListener('resize', sizeMedia, { passive: true });

  const swiperBanner = new Swiper(sliderEl, {
    loop: true,
    roundLengths: true,
    disableOnInteraction: true,
    speed: 1000,
    autoplay: enableAutoplay
      ? { delay: autoplayDelay, disableOnInteraction: false }
      : false,
    pagination: {
      el: banner.querySelector('.homepage-banner__pagination'),
      clickable: true,
      renderBullet: function (index, className) {
        const total = sliderEl.querySelectorAll('.swiper-slide').length;
        const loadSlide = strings.loadSlide || 'Go to slide';
        const of = strings.sliderOf || 'of';
        const label = `${loadSlide} ${index + 1} ${of} ${total}`;
        return `<button type="button" class="${className}" aria-label="${label}"></button>`;
      },
    },
    navigation: {
      nextEl: banner.querySelector('.swiper-button-next'),
      prevEl: banner.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      768: {
        allowTouchMove: false,
      },
    },
  });

  function syncPaginationAriaCurrent(swiper) {
    const paginationEl = swiper.pagination?.el;
    if (!paginationEl) return;
    const index =
      typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    paginationEl.querySelectorAll('button.swiper-pagination-bullet').forEach(function (btn, i) {
      if (i === index) {
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
  }

  swiperBanner.on('slideChange', function () {
    syncPaginationAriaCurrent(swiperBanner);
  });
  syncPaginationAriaCurrent(swiperBanner);

  const bannerButtons = banner.querySelectorAll(
    '.swiper-slide a[href]:not([class="absolute inset-0 z-10"])'
  );
  bannerButtons.forEach((button) => {
    button.addEventListener('mouseenter', function () {
      this.style.opacity = '0.9';
    });
    button.addEventListener('mouseleave', function () {
      this.style.opacity = '1';
    });
  });
});

